module.exports = "/_next/static/images/popup-content-1-513f77b67196c99da2368ab56d3feae9.png";